import React, { Component } from 'react';
import './CreateOrder.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import MapsNewOrder from '../Components/Maps/MapsNewOrder';
import searchbule from '../../image/searchbule.svg'
import arrow from '../../image/arrow.svg'

import calendar from '../../image/calendar.svg'
import save from '../../image/save.svg'
import iconrightwhite from '../../image/iconrightwhite.svg'
import promocode from '../../image/promocode.svg'
import axios from 'axios'
import { LinkAPI } from '../../API/API'
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import HandleRes from '../Components/HandleRes/HandleRes';
import moment from 'moment';


class CreateOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            categories: [],
            savedlocations: [],
            inRequest:false,
            clients:[],
            usemaps:true,
            balance: "",
            categoryselect: "",
            quantity: "",
            receiver: "",
            phone: "",
            deliverynote: "",
            collectMoney: false,
            amount: 0,
            promocode: "",
            promocodediscount: 0,
            weight: 1,
            payment: "",
            pickupdate:new Date() ,
            pickupaddress_name: "",
            pickupaddress_alias: "",
            address_name: "",
            dropoffaddress_alias: "",
            pickupcoordinates: [],
            coordinates: [],
            weightprice: 16,
            tripPrice: 17,
            orderPrice: 33,
            totalPrice: 33,
            categoryselectError: "",
            quantityError: "",
            receiverError: "",
            phoneError: "",
            collectMoneyError: "",
            amountError: "",
            weightError: "",
            paymentError: "",
            pickupdateError: "",
            pickupaddress_nameError: "",
            pickupaddress_aliasError: "",
            dropoffaddress_nameError: "",
            dropoffaddress_aliasError: "",
            startDate: new Date(),
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            errordataCodemessage: false,
            errordatamessageCodetext: '',
            hasError: false,

        };
        this.handleChange = this.handleChange.bind(this);
        this.calculasrorTotal = this.calcularorTotal.bind(this)
        this.handleChangedate = this.handleChangedate.bind(this);

        this.getbalance()
        this.savedlocations()
     
    }
    
    handleChangedate(date) {
        let datenew = moment(date).format()
        this.setState({
            pickupdate: datenew,
            startDate: date
        });
    }
    // handlereset = (e)=>{
    //     e.preventDefault();

    //     this.setState({
    //         categoryselect: "",
    //         quantity: "",
    //         receiver: "",
    //         phone: "",
    //         deliverynote: "",
    //         collectMoney: false,
    //         amount: "",
    //         promocode: "",
    //         weight: "",
    //         payment: "",
    //         pickupdate: "",
    //         pickupaddress_name:"",
    //         pickupaddress_alias:"",
    //         dropoffaddress_name:"",
    //         dropoffaddress_alias:"",
    //     }
    //     )
    // } 
    getbalance = () => {
 
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/getbalance`, {
            headers: {
                Authorization: `${Token}`
            } 
        }).then(res => {
            this.setState({
                categories: res.data.categories,
                balance: res.data.balance,
                clients:res.data.clients,
                numberOfOrders:res.data.numberOfOrders

            },()=>{
                if(this.state.numberOfOrders===0)
                this.setState({
                    promocode: "FIRST",
                },()=>{
                    this.checkpromocode()
                })
            })
        }).catch(error => {
            this.HandleError(error)
        })

    }
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("userToken")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }

    calcularorTotal = event => {
        this.setState({
            [event.target.name]: event.target.value
        });

        let weightprice = this.state.weightprice
        let tripPrice = this.state.tripPrice
        let promocodediscount = this.state.promocodediscount
        let weight = event.target.value
        let orderPrice = tripPrice + (weight * weightprice)
        let totalPrice = (tripPrice + (weight * weightprice)) - promocodediscount
        if(totalPrice<0)
        totalPrice=0
        this.setState({
            orderPrice: orderPrice,
            totalPrice: totalPrice
        })
    }

    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });

    };
    
    handleChangecheckbox = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value,
                amount:0
        });

    };
    setStateField = (object) => e => {
        this.setState({
            objectpickupaddress_name:  object.address_name,
            pickupaddress_name: object.address_name,
            pickupaddress_alias: object.address_alias,
            pickupcoordinates: object.location.coordinates,
        })
    }
    setStateFieldsReceiver = (object) => e => {

        this.setState({
            objectaddress_name:  object.name,
            receiver: object.name,
            phone: object.phone.replace(/^20+/, ''),
            address_name: object.location.address_name,
            dropoffaddress_alias: object.location.address_alias,
            coordinates: object.location.location.coordinates,

        })

    }
    
    savedlocations = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/savedlocations`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                savedlocations: res.data.businessOwner.savedlocations
            })
        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.data.message) {
                this.setState({
                   
                    errordataCodemessage: true,
            errordatamessageCodetext: error.response.data.message,
                })
            } else if (error.response.status === 402) {
                window.location.replace("/SignIn");
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    checkpromocode = event => {
        const { promocode } = this.state

        const Token = localStorage.getItem("userToken")
        axios.post(`${LinkAPI}/api/businessowner/checkpromocode`, { promocode: promocode }, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                promocodediscount: res.data.prmotion,
            })
            const total=this.state.orderPrice - this.state.promocodediscount
            
            this.setState({
                totalPrice: (total<0?0:total),
                errordataCodemessage: false,
                errordatamessageCodetext: '',
            })
        }).catch(error => {
            this.setState({
                promocodediscount: 0,
                totalPrice: this.state.orderPrice,
                
            })
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.data.message) {
                this.setState({
                   
                    errordataCodemessage: true,
            errordatamessageCodetext: error.response.data.message,
                })
            } else if (error.response.status === 402) {
                window.location.replace("/SignIn");
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })


    };
    setStatecoordinatesaddress_aliaspickup = (pickupcoordinates, pickupaddress_name) => {
        this.setState({
            pickupcoordinates: pickupcoordinates,
            pickupaddress_name: pickupaddress_name

        })

    }
    setStatecoordinatesaddress_alias = (coordinates, address_name) => {
        this.setState({
            coordinates: coordinates,
            address_name: address_name

        })
    }
    validate = () => {
        let quantityError = "";
        let receiverError = "";
        let phoneError = "";
        let amountError = "";
        let weightError = "";
        let categoryselectError = "";
        let paymentError = "";
        let collectMoneyError = "";
        let pickupdateError = "";
        let pickupaddress_nameError = "";
        let pickupaddress_aliasError = "";
        let dropoffaddress_nameError = "";
        let dropoffaddress_aliasError = "";
        let balanceError=""
        if (isNaN(this.state.quantity) || this.state.quantity < 1) {
            quantityError = "write quantity";
        }
        if ( isNaN(this.state.phone)|| this.state.phone.length < 10 ||this.state.phone.length > 11) {
            phoneError = "write phone Numper ";
        }
        if (this.state.categoryselect === "") {
            categoryselectError = "select category type ";
        }
        if (this.state.pickupdate ===null) {
            pickupdateError = "invalid Date";
        }
        
        if (this.state.collectMoney === true) {
            if (isNaN(this.state.amount) || this.state.amount < 1) {
                amountError = "wrong amount ";
            }
        }
        if (this.state.receiver.length < 2) {
            receiverError = "write receiver name";
        }
        if (isNaN(this.state.weight) || this.state.weight < 1) {
            weightError = "write weight ";
        }
        if (this.state.payment === "") {
            paymentError = "choose payment  ";
        }
        if (this.state.collectMoney !== false && this.state.collectMoney !== true) {
            collectMoneyError = "wrong";
        }
        if (this.state.payment !== "cash" && this.state.payment !== "wallet") {
            paymentError = "choose payment  ";
        }
        if (this.state.pickupaddress_name.length < 2 || !isNaN(this.state.pickupaddress_name)) {
            pickupaddress_nameError = "select your location correct";
        }
        if (this.state.pickupcoordinates.length<1) {
            pickupaddress_nameError = "select your location correct";
        }
        if (this.state.pickupaddress_alias.length < 2 || !isNaN(this.state.address_alias)) {
            pickupaddress_aliasError = "write your Address correct";
        }
        if (this.state.address_name.length < 5 || !isNaN(this.state.address_name)) {
            dropoffaddress_nameError = "select your location correct";
        }
        if (this.state.coordinates.length<1) {
            dropoffaddress_nameError = "select your location correct";
        }
        if (this.state.dropoffaddress_alias.length < 5 || !isNaN(this.state.dropoffaddress_alias)) {
            dropoffaddress_aliasError = "write your Address correct";
        }
        
        if (this.state.balance <this.state.totalPrice&&this.state.payment==="wallet") {
            balanceError = "you can't pay by wallet";
        }
        if (quantityError || phoneError || receiverError || weightError || categoryselectError || paymentError ||balanceError|| collectMoneyError || amountError || pickupdateError || pickupaddress_nameError || pickupaddress_aliasError || dropoffaddress_nameError || dropoffaddress_aliasError) {
            this.setState({ quantityError, phoneError, receiverError, weightError, categoryselectError, paymentError, balanceError,collectMoneyError, amountError, pickupdateError, pickupaddress_nameError, pickupaddress_aliasError, dropoffaddress_nameError, dropoffaddress_aliasError });
            return false;
        }

        return true;
    };

    handleSubmitCreateOrder = event => {

        event.preventDefault();
        const { categoryselect, quantity,promocode, receiver, phone, deliverynote, orderPrice, totalPrice, amount, weight, payment, pickupdate, pickupaddress_name, pickupaddress_alias, address_name, dropoffaddress_alias, pickupcoordinates, coordinates } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validate();
        if (isValid) {
            this.setState({inRequest:true})

            // clear form
            axios.post(`${LinkAPI}/api/businessowner/neworder`, {
                category: categoryselect,
                quantity: quantity,
                pickupDate: pickupdate,
                pickupLocation: {
                    address_name: pickupaddress_name,
                    address_alias: pickupaddress_alias,
                    location: {
                        coordinates: pickupcoordinates
                    }
                },
                dropoffLocation: {
                    address_name: address_name,
                    address_alias: dropoffaddress_alias,
                    location: {
                        coordinates: coordinates
                    }
                },
                note: deliverynote,
                promocode:promocode,
                orderPrice: orderPrice,
                totalPrice: totalPrice,
                reciver: {
                    name: receiver,
                    phone: 20+phone.replace(/^0+/, '')
                },
                payment: payment,
                status: 1,
                amount: amount,
                weight: weight
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
            ).then(res => {
                const url = "/OrderConfirmation/" + res.data.ordernumber
                // window.location.replace(url);
                this.props.history.push(url)
            }).catch(error => {
                this.HandleError(error)
            })
        }
    };
    handleSubmitCreateOrderDraft = event => {
        event.preventDefault();
        const { categoryselect, quantity, receiver, phone, deliverynote, orderPrice, totalPrice, amount, weight, payment, pickupdate, pickupaddress_name, pickupaddress_alias, address_name, dropoffaddress_alias, pickupcoordinates, coordinates } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validate();
        if (isValid) {
            this.setState({inRequest:true})

            // clear form
            axios.post(`${LinkAPI}/api/businessowner/neworder`, {
                category: categoryselect,
                quantity: quantity,
                pickupDate: pickupdate,
                pickupLocation: {
                    address_name: pickupaddress_name,
                    address_alias: pickupaddress_alias,
                    location: {
                        coordinates: pickupcoordinates
                    }
                },
                dropoffLocation: {
                    address_name: address_name,
                    address_alias: dropoffaddress_alias,
                    location: {
                        coordinates: coordinates
                    }
                },
                note: deliverynote,
                orderPrice: orderPrice,
                totalPrice: totalPrice,
                reciver: {
                    name: receiver,
                    phone: 20+phone.replace(/^0+/, '')
                },
                payment: payment,
                status: 0,
                amount: amount,
                weight: weight
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
            ).then(res => {
                this.props.history.push("/Orders")

            }).catch(error => {
                this.HandleError(error)
            })
        }
    };


    render() {
        document.title ="Kayn | Create Order"; 
        document.getElementsByTagName("META")[1].content="Kayn Create Order";
        document.documentElement.lang = 'en';
        return (
            <div>
                <div className="AppEN container-fluid px-0" >
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                            <NabarClient />
                        </div>
                        <div className="client col-md-11 px-lg-5">
                            <HeaderTool />

                            <h3 className=" fontsize9 my-2">Create New Orders</h3>
                            {(this.state.numberOfOrders===0?
                                <div class="alert alert-success mx-auto col-md-4 text-center" role="alert">
                                Get 200 EGP off on your frist order use promo FIRST 
                              </div>
                                :'')}
                            <div className="CreateOrder  m-lg-3 p-3 shadow rounded">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group  ">
                                                <select className={"form-control badge-pill text-muted" + (this.state.categoryselectError ? ' is-invalid' : '')} name="categoryselect" value={this.state.categoryselect} onChange={this.handleChange} >
                                                    <option  >PRODUCT CATEGORY ...</option>
                                                    
                                                    {
                                                        this.state.categories.map((x, i) => (
                                                            <option key={i} value={x}>{x}</option>

                                                        ))
                                                    }
                                                </select>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.categoryselectError}
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group  ">
                                                <input type="number" className={"form-control badge-pill counter " + (this.state.quantityError ? 'is-invalid' : '')} placeholder="Product Quantity" name="quantity" value={this.state.quantity} onChange={this.handleChange} />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.quantityError}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4 text-center mb-2">
                                            <div className="form-group has-search  mb-0 pt-0">
                                                <span className="fontsize11 font-weight-bold m-1 ">Pick up date</span>
                                                <img className="m-1" src={calendar} alt="calendars" />
                                                <DatePicker
                                                    className="badge-pill btn border"
                                                    dateFormat="MMMM d, yyyy "
                                                    selected={this.state.startDate}
                                                    onChange={ date=>this.handleChangedate(date)}
                                                    minDate={new Date()}
                                                    placeholderText="Select a date"
                                                />
                                            </div>
                                            <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                {this.state.pickupdateError}
                                            </div>
                                        </div>

                                        {/* map */}

                                        <MapsNewOrder  key={[this.state.objectaddress_name,this.state.objectpickupaddress_name]}  state={this.state} setStatecoordinatesaddress_aliaspickup={this.setStatecoordinatesaddress_aliaspickup} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                                        <div className="col-md-6 px-lg-5 text-center">
                                            <div className="form-group mb-2 p-0 search_div" id="pac-container2">
                                                <img className="mr-1 img_input" src={searchbule} alt="search" />
                                                <input type="text " id="pac-input2" className={"px-5 search_input form-control badge-pill " + (this.state.pickupaddress_nameError ? 'is-invalid' : '')} placeholder="PICK UP LOCATION" name="pickupaddress_name" value={this.state.pickupaddress_name} onChange={this.handleChange} />
                                                <img className="mr-1 img_input2 pointer" src={arrow} alt="arrow" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />

                                                <div className="dropdown-menu dropdownmapmenu mt-1" aria-labelledby="dropdownMenuButton">

                                                    {this.state.savedlocations.length>0?
                                                        this.state.savedlocations.map((x, i) => (
                                                            <a className="dropdown-item pointer" key={i} onClick={this.setStateField(x)}>{x.address_name}</a>
                                                        )):<p className="text-center">No Address in (Client Adderss)</p>}
                                                </div>
                                            </div>
                                            <div className="mb-2" style={{ fontSize: 12, color: "red" }}>
                                                {this.state.pickupaddress_nameError}
                                            </div>
                                            <div id="map2"></div>
                                            <div className="form-group col-12 text-left mt-2">
                                                <input type="text" className={"p-3 search_input form-control badge-pill " + (this.state.pickupaddress_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="pickupaddress_alias" value={this.state.pickupaddress_alias} onChange={this.handleChange} />
                                                <div className="mx-5 px-5" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.pickupaddress_aliasError}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6 px-lg-5 text-center">
                                            <div className="form-group mb-2 p-0 search_div" id="pac-container">
                                                <img className="mr-1 img_input " src={searchbule} alt="search" />
                                                <input type="text" id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.state.dropoffaddress_nameError ? 'is-invalid' : '')} placeholder="Search" placeholder="DROP OFF LOCATION" name="address_name" value={this.state.address_name} onChange={this.handleChange} />

                                            </div>
                                            <div className="mb-2" style={{ fontSize: 12, color: "red" }}>
                                                {this.state.dropoffaddress_nameError}
                                            </div>
                                            <div id="map"></div>
                                            <div className="form-group col-12 text-left mt-2">
                                                <input type="text" className={"form-control badge-pill p-3 " + (this.state.dropoffaddress_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="dropoffaddress_alias" value={this.state.dropoffaddress_alias} onChange={this.handleChange} />
                                                <div className="mx-5 px-5" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.dropoffaddress_aliasError}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4  my-3">
                                            <div className="form-group  ">
                                                <input type="text" className={"form-control badge-pill " + (this.state.receiverError ? 'is-invalid' : '')} placeholder="RECEIVER" name="receiver" value={this.state.receiver} onChange={this.handleChange} />
                                                <img className="mr-1 mt-1 img_input3 pointer" src={arrow} alt="arrow" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />

                                                <div className="dropdown-menu  dropdownmapmenu2 mt-2" aria-labelledby="dropdownMenuButton">

                                                    {this.state.clients.length>0?
                                                        this.state.clients.map((x, i) => (
                                                            <a className="dropdown-item pointer" key={i} onClick={this.setStateFieldsReceiver(x)}>{x.name}</a>
                                                        )):<p className="text-center">No Clients in (MyClients)</p>}
                                                </div>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.receiverError}
                                                </div>
                                            </div>
                                            <div className="form-group  nocounter">
                                            <div className="relative">
                            <span className="codephone">+20</span>
                                                <input type="number" className={"form-control pl-5 badge-pill  " + (this.state.phoneError ? 'is-invalid' : '')} placeholder="PHONE NUMER" name="phone" value={this.state.phone} onChange={this.handleChange} />
                                                </div>

                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.phoneError}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4  my-3">
                                            <div className="form-group  ">
                                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="DELIVERYNOTE" name="deliverynote" value={this.state.deliverynote} onChange={this.handleChange}></textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-4  my-3">
                                            <div className="form-check text-center mb-3">
                                                <input className="form-check-input" type="checkbox" id="gridCheck1" name="collectMoney" value={this.state.collectMoney} onChange={this.handleChangecheckbox} />
                                                <label className="form-check-label" htmlFor="gridCheck1">
                                                    Collect money from the receiver
                                        </label>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.collectMoneyError}
                                                </div>
                                            </div>
                                            <div className="form-group  ">
                                                <input type="number" className={"form-control badge-pill" + (this.state.amountError ? ' is-invalid' : '')} placeholder="AMOUNT" name="amount" value={this.state.amount} onChange={this.handleChange}
                                                    disabled={(this.state.collectMoney ? '' : 'disabled')}
                                                />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.amountError}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h3 className=" fontsize9  mx-3">Payment details</h3>
                                    <hr />
                                    <div className="row px-3">
                                        <div className="col-md-6 ">
                                            <div className="form-check mx-3 x">
                                                <input className="form-check-input " type="radio" value="cash" name="payment" onChange={this.handleChange} />
                                                <label className="form-check-label " htmlFor="gridRadios1">
                                                    Cash
                                        </label>
                                            </div>
                                            <div className="form-check  mx-3 mb-1">
                                                <input className="form-check-input my-3 " type="radio" value="wallet" name="payment" onChange={this.handleChange} />
                                                <label className="form-check-label mt-1" htmlFor="gridRadios2">
                                                    Wallet <span className="ml-lg-5 ml-1 text-muted fontsize11">Current balance:</span> <span className="mx-2 fontsize9 font-weight-bold bluecolor">{this.state.balance}</span>
                                                </label>

                                            </div> 

                                            <div style={{ fontSize: 12, color: "red" }}>
                                                {this.state.paymentError}
                                            </div>
                                        </div>
                                        <div className="col-md-5 mx-auto px-2 text-center">
                                            <div className="form-group    search_div">
                                                <input type="text" className="form-control badge-pill pl-7" placeholder="PROMO CODE" name="promocode" value={this.state.promocode} onChange={this.handleChange} />
                                                <img className="img_promocode" src={promocode} alt="promocode" />
                                                <a onClick={this.checkpromocode} className="btn badge-pill px-2 btnpromocodo my-1  text-white  bluebg">Apply</a>
                                                
                                            </div>
                                            {(this.state.errordataCodemessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessageCodetext}
                                                    </div> : '')}

                                            <div className="form-group ">
                                                <input type="number" className={"form-control badge-pill " + (this.state.weightError ? 'is-invalid' : '')} data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom" placeholder="Weight .kg" name="weight" value={this.state.weight} onChange={this.calcularorTotal} />
                                                <div style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.weightError}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6 px-3 ">
                                            <p className="m-0  mt-3" >Sub-total : <span className="float-right">{this.state.orderPrice}  EGP</span></p>
                                            {(this.state.promocodediscount == 0 ?
                                                ''       
                                                : 
                                                <p className="text-danger" >Promotions : <span className=" float-right">-{this.state.promocodediscount} EGP</span></p>
                                                )}
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.balanceError}
                                                </div>
                                    <hr />
                                    <p className=" col-md-6   mt-3 fontsize9 font-weight-bold " >TOTAL : <span className=" fontsize9 font-weight-bold  float-right">{this.state.totalPrice} EGP</span></p>
                                    <div className="text-center d-sm-flex justify-content-sm-around  flex-wrap my-3">
                                        <button onClick={this.handleSubmitCreateOrder} className="text-white badge-pill p-2 pl-1 px-3 my-1 border shadow bluebg " disabled={(this.state.inRequest?true:false)}><img className="mr-1" src={iconrightwhite} alt="rightwhite" /> CONFIRM ORDER</button>
                                        <button onClick={this.handleSubmitCreateOrderDraft} className="btn badge-pill p-2 pl-1 px-3 my-1 border shadow bg-white"disabled={(this.state.inRequest?true:false)}><img className="mr-1" src={save} alt="save" />SAVE TO DRAFT</button>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}


export default CreateOrder;